var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { ToggleCard } from "../../../../Shared/components/ToggleCard/ToggleCard";
import { CardLayout } from "../../../../Shared/components/CardLayout/CardLayout";
import { useRecipeType } from "./useRecipeType";
import { RecipeTypeText } from "./recipeType-types";
/**
 * RecipeType - Displays recipe types as cards or buttons with a tooltip.
 * Can be configured to use a slider or a grid.
 */
export const RecipeType = ({ sequenceNumber }) => {
    const _a = useRecipeType(sequenceNumber), { recipeTypesToRender, selectedRecipeType, noRecipeTypesToDisplay, imageBaseUrl, IsGridLayout, CardDescriptionLines, showImage, recipeTypeDisplayMode, handleRecipeTypeChange, CenterCards, showDescription, imageHeight } = _a, restProps = __rest(_a, ["recipeTypesToRender", "selectedRecipeType", "noRecipeTypesToDisplay", "imageBaseUrl", "IsGridLayout", "CardDescriptionLines", "showImage", "recipeTypeDisplayMode", "handleRecipeTypeChange", "CenterCards", "showDescription", "imageHeight"]);
    if (noRecipeTypesToDisplay) {
        return _jsx(Typography, { children: RecipeTypeText.NoRecipesTypesAvailable });
    }
    return (_jsx(CardLayout, Object.assign({ isGridLayout: Boolean(IsGridLayout), CenterCards: true, cardsToRender: recipeTypesToRender.map((recipeType) => {
            const selected = selectedRecipeType ? selectedRecipeType.recipeTypeId === recipeType.recipeTypeId : false;
            return (_jsx(ToggleCard, { onClick: () => handleRecipeTypeChange(recipeType.recipeTypeId), selected: selected, itemDisplayMode: recipeTypeDisplayMode, description: recipeType.description, descriptionLines: CardDescriptionLines, title: recipeType.recipeTypeName, image: showImage && recipeType.defaultImage && `${imageBaseUrl}${recipeType.defaultImage}`, imageHeight: imageHeight, showImage: showImage, showDescription: showDescription }, recipeType.recipeTypeId));
        }) }, restProps)));
};
